<app-alert-component></app-alert-component>

<div [@routeAnimations]="o.isActivated ? o.activatedRoute : ''">
  <ng-container *ngIf="loadingRoute">
    <div class="absolute top-0 left-0 right-0">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </ng-container>
  <ngx-loading-bar color="#4c8477" height='4px'></ngx-loading-bar>
  <router-outlet #o="outlet"/>
</div>
